<template>
  <div>
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row v-if="!p_callFrom || p_callFrom !== 'default_container'" style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['support_details'][StoreLang] }}
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>
    <template v-if="p_callFrom == 'default_container'">
      <div style="font-size: 14px; margin-top: 40px;">
        <template v-if="!d_supportGetLoading"> 
          <b-row>
            <b-col cols="12">
              <strong> <i class="fa fa-check-square-o"></i> </strong>
              <b> {{ StoreLangTranslation.data['support_operation_name'][StoreLang] }} </b>
            </b-col>
          </b-row>
          <b-row style="padding: 10px 10px 0px 10px;">
            <b-col cols="12">
              {{ d_userSupportData.operation_name }}
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col cols="12">
              <strong> <i class="fa fa-check-square-o"></i> </strong>
              <b> {{ StoreLangTranslation.data['support_operation_note'][StoreLang] }} </b>
            </b-col>
          </b-row>
          <b-row style="padding: 10px 10px 0px 10px;">
            <b-col cols="12">
              {{ d_userSupportData.operation_note }}
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col cols="12">
              <strong> <i class="fa fa-check-square-o"></i> </strong>
              <b> {{ StoreLangTranslation.data['comments'][StoreLang] }} </b>
            </b-col>
          </b-row>

          <template v-if="d_worganizationOperationData.data && d_worganizationOperationData.data.general && d_worganizationOperationData.data.general.comment && d_worganizationOperationData.data.general.comment.list && d_worganizationOperationData.data.general.comment.list.length > 0">
              <template v-for="(com, com_ind) in d_worganizationOperationData.data.general.comment.list">
                <b-card :key="'d_worganizationOperationData.data.general.comment.list_' + com_ind" no-body :style="com_ind % 2 === 0 ? 'margin: 3px; background-color: lightyellow;' : 'margin: 3px; background-color: ghostwhite;'">
                  <b-row>
                    <b-col sm="12" md="12">
                      <img src="@/icon/9370.png" style="border-radius: 3px; width: 20px;" />
                      <template v-if="com.customer_name && com.customer_name.val">
                        {{ com.customer_name && com.customer_name.val ? com.customer_name.val : '' }}
                      </template>
                      <template v-else>
                        {{ com.who_commented.val.label }} 
                      </template>
                    </b-col>
                  </b-row>
                  <b-row style="padding: 10px; margin: 0px;">
                    <b-col sm="12" md="12">
                      <div v-html="com.message.val"> </div>
                    </b-col>
                  </b-row>
                  <b-row style="padding: 0px 10px 10px 10px; margin: 0px;">
                    <b-col sm="12" md="12">
                      <div style="float: right;">{{ f_dateFormat(com.comment_datetime.val, 'year-month-day hh:mm') }}</div>
                    </b-col>
                  </b-row>
                </b-card>
              </template>
          </template>
          <b-row v-if="d_userSupportData.status === '1'" style="margin-top: 20px; padding: 5px; ">
              <b-col cols="12">
                <b-form-textarea v-model="d_commentNew" rows="5" :placeholder="'maksimum 500 karakter'"></b-form-textarea>
              </b-col>
            </b-row>
          <b-row v-if="d_userSupportData.status === '1'" >
            <b-col sm="12" lg="7">
              <b-button size="sm" variant="outline-danger" @click="f_supportTerminate()">
                <i class="fa fa-times-circle"></i>
                {{ StoreLangTranslation.data['support_terminate'][StoreLang] }}
              </b-button>
            </b-col>
            <b-col sm="12" lg="5" style="text-align: right;">
              <b-button size="sm" variant="white" @click="f_newSupportComment()">
                <i class="fa fa-plus-circle"></i>
                {{ StoreLangTranslation.data['comment_add'][StoreLang] }}
              </b-button>
            </b-col>
          </b-row>
        </template>
        <template v-else>
          <b-spinner variant="primary" label="Continuing" style="margin: 2px;"></b-spinner>
        </template>
      </div>
    </template>
    <b-row v-else style="font-size: 14px;">
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">
        <!--
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              {{ d_userSupportWdm['0']['parameters']['0']['name']['translation'][StoreLang] }}
            </b-col>
            <b-col sm="12" lg="8">
              <select class="form-control" v-model="d_userSupportData.status">
                <option v-for="(op, op_index) in d_userSupportWdm['0']['parameters']['0'].options" :value="op.value">
                  {{ op.translation[StoreLang] }}
                </option>
              </select>
            </b-col>
          </b-row>
        -->

          <b-row>
            <b-col cols="4">
              <strong> <i class="fa fa-check-square-o"></i> </strong>
              <b> {{ StoreLangTranslation.data['support_operation_name'][StoreLang] }} </b>
            </b-col>
            <b-col cols="8">
            </b-col>
          </b-row>
          <b-row style="padding: 10px;">
            <b-col cols="12">
              {{ d_userSupportData.operation_name }}
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col cols="4">
              <strong> <i class="fa fa-check-square-o"></i> </strong>
              <b> {{ StoreLangTranslation.data['support_operation_note'][StoreLang] }} </b>
            </b-col>
            <b-col cols="8">
            </b-col>
          </b-row>
          <b-row style="padding: 10px;">
            <b-col cols="12">
              {{ d_userSupportData.operation_note }}
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col cols="4">
              <strong> <i class="fa fa-check-square-o"></i> </strong>
              <b> {{ StoreLangTranslation.data['comments'][StoreLang] }} </b>
            </b-col>
            <b-col cols="8">
            </b-col>
          </b-row>

        <template v-if="d_worganizationOperationData.data && d_worganizationOperationData.data.general && d_worganizationOperationData.data.general.comment && d_worganizationOperationData.data.general.comment.list && d_worganizationOperationData.data.general.comment.list.length > 0">
          <template v-for="(com, com_ind) in d_worganizationOperationData.data.general.comment.list">
            <b-card :key="'d_worganizationOperationData.data.general.comment.list_' + com_ind" no-body :style="com_ind % 2 === 0 ? 'margin: 3px; background-color: lightyellow;' : 'margin: 3px; background-color: ghostwhite;'">
              <b-row>
                <b-col sm="12" md="10">
                  <img src="@/icon/9370.png" style="border-radius: 3px; width: 20px;" />
                  <template v-if="com.customer_name && com.customer_name.val">
                    {{ com.customer_name && com.customer_name.val ? com.customer_name.val : '' }}
                  </template>
                  <template v-else>
                    {{ com.who_commented.val.label }} 
                  </template>
                </b-col>
                <b-col sm="12" md="2">
                  {{ f_dateFormat(com.comment_datetime.val, 'year-month-day hh:mm') }}
                </b-col>
              </b-row>
              <b-row style="padding: 10px; margin: 0px;">
                <b-col sm="12" md="12">
                  <div v-html="com.message.val"> </div>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </template>
        <b-row v-if="d_userSupportData.status === '1'" style="margin-top: 20px; padding: 5px; ">
            <b-col cols="12">
              <b-form-textarea v-model="d_commentNew" rows="5" :placeholder="'maksimum 500 karakter'"></b-form-textarea>
            </b-col>
          </b-row>
        <b-row v-if="d_userSupportData.status === '1'" style="margin: 3px;">
          <b-col sm="12" lg="6">
            <b-button variant="outline-danger" @click="f_supportTerminate()">
              <i class="fa fa-times-circle"></i>
              {{ StoreLangTranslation.data['support_terminate'][StoreLang] }}
            </b-button>
          </b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
            <b-button variant="white" @click="f_newSupportComment()">
              <i class="fa fa-plus-circle"></i>
              {{ StoreLangTranslation.data['comment_add'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import moment from "moment";
import { mapGetters } from 'vuex';
export default {
  name: 'SupportDetail',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreDevice: 'StoreDevice',
  }),
  components: {},
  props: {
    p_userSupportClientID: {
      type: String,
      required: false
    },
    p_mailSupportClientID: {
      type: String,
      required: false
    },
    p_callFrom: {
      type: String,
      required: false
    },
    p_newMessage: {
      type: Boolean,
      required: true
    },
    p_mail: {
      type: Object,
      required: false
    },
    f_clearMailInfo: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      d_commentNew: '',
      d_worganizationOperationData: '',
      d_user: '',
      d_mail: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_userSupportData: {
        'status': '',
        'organization_id': '',
        'operation_id': '',
        'subject': '',
        'operation_update_date': '',
        'shop_bundle_client_id': '',
        'shop_bundle_product_client_id': '',
        'operation_name': '',
        'operation_note': '',
        'shop_client_id': '',
        'created_by': '',
        'created_at': '',
        'cancelled_by': '',
        'cancel_date': '',
      },
      d_operationTotalMessageCount: '',
      d_intervalId: null,
      d_supportGetLoading: false,

    };
  },
  created: function () {
    this.d_user = JSON.parse(localStorage.getItem('user'));
    if (this.p_mail) {
      this.d_mail = {
        'mail': this.p_mail['mail'],
        'mail_approve_code': this.p_mail['mail_approve_code'],
      }
    } else{
      this.d_mail = JSON.parse(localStorage.getItem('mail'));
    }
     // this.f_langEligibleParameterProcess();
  },
  beforeMount () {},
  mounted: function () {
    if (this.p_userSupportClientID) {
      this.f_userSupportGet();
      this.d_intervalId = setInterval(() => {
        this.f_userSupportGet('timer');
      }, 30000);
    } else if (this.p_mailSupportClientID) {
      this.f_mailSupportGet();
      this.d_intervalId = setInterval(() => {
        this.f_mailSupportGet('timer');
      }, 30000);

    }
    // console.log(this.StoreLangList);
    // console.log(this.StoreFrontendSettings);
  },
  beforeDestroy() {
    if (this.d_intervalId) {
      clearInterval(this.d_intervalId);
      this.d_intervalId = null;
    }
  },
  methods: {
    f_newSupportComment: function () {
      if (this.p_userSupportClientID) {
        this.f_userSupportComment()
      } else if (this.p_mailSupportClientID) {
        this.f_mailSupportComment()
      }
    },
    f_setLiveSeen: function () {
      let query = 'user_client_id=' + this.d_user.username;
      query += '&user_support_client_id=' + this.p_userSupportClientID;
      let data = {};
      ServiceFunctions.user_support_live_seen(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            // console.log("set seen")
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_setLiveSeenMail: function () {
      let query = 'mail_support_client_id=' + this.p_mailSupportClientID;
      let data = {
        'mail': this.d_mail['mail'],
        'mail_approve_code': this.d_mail['mail_approve_code'],
      };
      ServiceFunctions.mail_support_live_seen(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            // console.log("set seen")
          } else if (resp.data.error && this.f_clearMailInfo) {
            alert(resp.data.status_code + ' = ' + resp.data.error);
            this.f_clearMailInfo();
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_dateFormat: function (date, date_type='year-month-day') {
      if (date) {
        if (date_type === 'year-month-day') {
          if (this.StoreLang === 'tr') {
            let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY");
            return x;
          } else {
            let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("YYYY/MM/DD");
            return x;
          }
        } else if (date_type === 'year-month-day hh:mm') {
          let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY HH:MM");
          return x;
        }
      } else {
        return "";
      }
    },
    f_langEligibleParameterProcess: function () {
      let lang_eligible_variables = [];
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          if (!this.d_userSupportData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label]) {
            this.d_userSupportData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
          }
        }
      }
    },
    f_supportTerminate: function () {
      if (confirm(this.StoreLangTranslation.data['do_you_confirm_the_terminate_support'][this.StoreLang])) {
        if (this.d_user && this.d_user.username) {
          this.f_userSupportTerminate();
        } else if (this.d_mail && this.d_mail.mail && this.d_mail.mail_approve_code) {
          this.f_mailSupportTerminate();
        }
      }
    },
    f_userSupportTerminate: function () {
      this.d_userSuppportList = [];
      this.d_supportGetLoading = true;
      let query = 'user_client_id=' + this.d_user.username;
      query += '&user_support_client_id=' + this.p_userSupportClientID;
      let data = {};
      ServiceFunctions.user_support_terminate(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.$emit('changeRefreshSupportList', true);
            this.f_userSupportGet();
            if (this.d_intervalId) {
              clearInterval(this.d_intervalId);
              this.d_intervalId = null;
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_mailSupportTerminate: function () {
      this.d_userSuppportList = [];
      this.d_supportGetLoading = true;
      let query = 'mail_support_client_id=' + this.p_mailSupportClientID;
      let data = {
        'mail': this.d_mail['mail'],
        'mail_approve_code': this.d_mail['mail_approve_code'],
      };
      ServiceFunctions.mail_support_terminate(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.$emit('changeRefreshSupportList', true);
            this.f_mailSupportGet();
            if (this.d_intervalId) {
              clearInterval(this.d_intervalId);
              this.d_intervalId = null;
            }
          } else if (resp.data.error && this.f_clearMailInfo) {
            alert(resp.data.status_code + ' = ' + resp.data.error);
            this.f_clearMailInfo();
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_userSupportGet: function (call_from='') {
      if (call_from !== 'timer') {
        this.d_userSupportData = '';
        this.d_worganizationOperationData = '';
        this.d_supportGetLoading = true;
      }
      let query = 'user_support_client_id=' + this.p_userSupportClientID;
      query += '&data_type=value_mode';
      let data = {};
      ServiceFunctions.user_support_get(query, data)
        .then(resp => {
          this.d_supportGetLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.data) {
              this.d_userSupportData = resp.data.data;
              this.d_worganizationOperationData = resp.data.worganization_operation;
              // this.f_langEligibleParameterProcess();
              this.d_operationTotalMessageCount = '0';
              if (this.d_worganizationOperationData && this.d_worganizationOperationData.data && this.d_worganizationOperationData.data.general && this.d_worganizationOperationData.data.general.comment &&this.d_worganizationOperationData.data.general.comment.list) {
                this.d_operationTotalMessageCount = String(this.d_worganizationOperationData.data.general.comment.list.length);
              }
              if (call_from === 'timer') {
                const seen_messages_raw = localStorage.getItem('support_seen_message_count');
                let seen_messages = seen_messages_raw ? JSON.parse(seen_messages_raw) : {};
                if (seen_messages && [this.p_userSupportClientID]) {
                  let seen_message_count = seen_messages[this.p_userSupportClientID];
                  if (parseInt(this.d_operationTotalMessageCount) > parseInt(seen_message_count)) {
                    this.$emit('changeNewMessage', true);
                    seen_messages[this.p_userSupportClientID] = this.d_operationTotalMessageCount;
                    localStorage.setItem('support_seen_message_count', JSON.stringify(seen_messages));
                    this.f_setLiveSeen();
                  }
                }
              } else {
                const seen_messages_raw = localStorage.getItem('support_seen_message_count');
                let seen_messages = seen_messages_raw ? JSON.parse(seen_messages_raw) : {};
                seen_messages[this.p_userSupportClientID] = this.d_operationTotalMessageCount;
                localStorage.setItem('support_seen_message_count', JSON.stringify(seen_messages));
              }
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_mailSupportGet: function (call_from='') {
      if (call_from !== 'timer') {
        this.d_userSupportData = '';
        this.d_worganizationOperationData = '';
        this.d_supportGetLoading = true;
      }
      let query = 'mail_support_client_id=' + this.p_mailSupportClientID;
      let data = {};
      ServiceFunctions.mail_support_get(query, data)
        .then(resp => {
          this.d_supportGetLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            let mail = ''
            let mail_approve_code = ''
            if (resp.data.mail_data && resp.data.mail_data.mail && resp.data.mail_data.mail_approve_code) {
              // this.d_mail['mail'] = resp.data.mail_data['mail'];
              // this.d_mail['mail_approve_code'] = resp.data.mail_data['mail_approve_code'];
              this.d_mail = {
                'mail':'',
                'mail_approve_code':'',
              }
              this.d_mail['mail'] = resp.data.mail_data.mail
              this.d_mail['mail_approve_code'] = resp.data.mail_data.mail_approve_code
              localStorage.setItem('mail', JSON.stringify({'mail': this.d_mail['mail'], 'mail_approve_code': this.d_mail['mail_approve_code']}));
            }
            if (resp.data.data) {
              this.d_userSupportData = resp.data.data;
              this.d_worganizationOperationData = resp.data.worganization_operation;
              // this.f_langEligibleParameterProcess();
              this.d_operationTotalMessageCount = '0';
              if (this.d_worganizationOperationData && this.d_worganizationOperationData.data && this.d_worganizationOperationData.data.general && this.d_worganizationOperationData.data.general.comment &&this.d_worganizationOperationData.data.general.comment.list) {
                this.d_operationTotalMessageCount = String(this.d_worganizationOperationData.data.general.comment.list.length);
              }
              if (call_from === 'timer') {
                const seen_messages_raw = localStorage.getItem('support_seen_message_count');
                let seen_messages = seen_messages_raw ? JSON.parse(seen_messages_raw) : {};
                if (seen_messages && seen_messages[this.p_mailSupportClientID]) {
                  let seen_message_count = seen_messages[this.p_mailSupportClientID];
                  if (parseInt(this.d_operationTotalMessageCount) > parseInt(seen_message_count)) {
                    this.$emit('changeNewMessage', true);
                    seen_messages[this.p_mailSupportClientID] = this.d_operationTotalMessageCount;
                    localStorage.setItem('support_seen_message_count', JSON.stringify(seen_messages));
                    this.f_setLiveSeenMail();
                  }
                }
              } else {
                const seen_messages_raw = localStorage.getItem('support_seen_message_count');
                let seen_messages = seen_messages_raw ? JSON.parse(seen_messages_raw) : {};
                seen_messages[this.p_mailSupportClientID] = this.d_operationTotalMessageCount;
                localStorage.setItem('support_seen_message_count', JSON.stringify(seen_messages));
              }
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else if (resp.data.error && this.f_clearMailInfo) {
            alert(resp.data.status_code + ' = ' + resp.data.error);
            this.f_clearMailInfo();
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_userSupportComment: function () {
      if (this.d_commentNew) {
        if (this.d_commentNew.length > 500) {
          alert(this.StoreLangTranslation.data['character_count_is_higher_than_expected'][this.StoreLang]);
        } else {
          this.d_supportGetLoading = true;
          let query = 'user_support_client_id=' + this.p_userSupportClientID;
          let data = {
            'comment': this.d_commentNew
          };
          ServiceFunctions.user_support_comment(query, data)
            .then(resp => {
              if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
                this.f_userSupportGet();
                this.d_commentNew = '';
              } else {
                alert(resp.data.status_code + ' = ' + resp.data.status_message);
              }
            });
        }
      } else {
        alert(this.StoreLangTranslation.data['please_write_your_comment'][this.StoreLang]);
      }
    },
    f_mailSupportComment: function () {
      if (this.d_commentNew) {
        if (this.d_commentNew.length > 500) {
          alert(this.StoreLangTranslation.data['character_count_is_higher_than_expected'][this.StoreLang]);
        } else {
          this.d_supportGetLoading = true;
          let query = 'mail_support_client_id=' + this.p_mailSupportClientID;
          let data = {
            'comment': this.d_commentNew,
            'mail': this.d_mail['mail'],
            'mail_approve_code': this.d_mail['mail_approve_code'],
          };
          ServiceFunctions.mail_support_comment(query, data)
            .then(resp => {
              if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
                this.f_mailSupportGet();
                this.d_commentNew = '';
              } else if (resp.data.error && this.f_clearMailInfo) {
                alert(resp.data.status_code + ' = ' + resp.data.error);
                this.d_supportGetLoading = false;
                this.f_clearMailInfo();
              } else {
                alert(resp.data.status_code + ' = ' + resp.data.status_message);
              }
            });
        }
      } else {
        alert(this.StoreLangTranslation.data['please_write_your_comment'][this.StoreLang]);
      }
    },
  },
  watch: {
    'p_userSupportClientID': function () {
      clearInterval(this.d_intervalId);
      this.d_intervalId = null;
      this.f_userSupportGet();
      this.d_intervalId = setInterval(() => {
        this.f_userSupportGet('timer');
      }, 30000);
    },
    'p_mailSupportClientID': function () {
      clearInterval(this.d_intervalId);
      this.d_intervalId = null;
      this.f_mailSupportGet();
      this.d_intervalId = setInterval(() => {
        this.f_mailSupportGet('timer');
      }, 30000);
    },
    'p_mail': function () {
      this.d_mail = {
        'mail': this.p_mail['mail'],
        'mail_approve_code': this.p_mail['mail_approve_code'],
      }
    }
  }
};

</script>

